/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3.8723 11.1002C6.635 7.3284 11.6895 5.819 16.145 7.7442c5.2095 2.2509 7.6276 8.3448 5.4009 13.6111-.1764.4172.0152.9.4279 1.0784.4128.1783.8904-.0154 1.0668-.4326 2.5795-6.1008-.2217-13.1604-6.2568-15.768-4.5292-1.957-9.5926-.8503-12.9278 2.4026a11.9027 11.9027 0 0 0-1.8109 2.2586l.9164-6.9482.0092-.148c-.0107-.3894-.2952-.7275-.6896-.7885-.4437-.0687-.8584.2393-.9264.6878L0 13.7187l9.915 1.368.1465.0093c.3852-.0109.7195-.2986.7798-.6973l.0091-.148c-.0107-.3894-.2953-.7274-.6897-.7883l-7.1504-.9649c.2537-.4948.5425-.9612.862-1.3973Zm-1.8678.114-.1453-.0518-.055.4066c.065-.1198.1318-.238.2003-.3548Z"
    clipRule="evenodd"
  />,
  'Undo'
);
